import _taggedTemplateLiteral from 'babel-runtime/helpers/taggedTemplateLiteral';

var _templateObject = _taggedTemplateLiteral(['\n    color: ', ';\n'], ['\n    color: ', ';\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n    list-style-type: none;\n    padding: 0;\n    margin: 1em 0 2em;\n    min-height: 50px;\n'], ['\n    list-style-type: none;\n    padding: 0;\n    margin: 1em 0 2em;\n    min-height: 50px;\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n'], ['\n']);

import styled from 'styled-components';

export var StyledHeader = styled.h6(_templateObject, function (props) {
    return props.theme.dormifyBlack;
});

export var StyledProductList = styled.ul(_templateObject2);

export var StyledProductListItem = styled.li(_templateObject3);